import { render } from "./ExampleComponent.vue?vue&type=template&id=9257200c&scoped=true"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"

import "./ExampleComponent.vue?vue&type=style&index=0&id=9257200c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9257200c"]])

export default __exports__